(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('uibModalWindow', function() {
    return {
      restrict: 'EA',
      link: function(scope, element) {
        return element.draggable({
          handle: '.modal-header',
          start: function() {
            return element.removeClass('fade');
          },
          stop: function() {
            return element.addClass('fade');
          }
        });
      }
    };
  });

}).call(this);
